const { axiosDefault, handleErrors } = require('../utils/defaults');

const visitingprogram = {
  save: async (contacts) => {
    try {
      const axios = axiosDefault();
      const { data } = await axios.post(`/api/visitingprogram`, contacts);

      return data;
    } catch (error) {
      return handleErrors(error);
    }
  },
};

export default visitingprogram;
